import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { BusinessForwardedItem } from 'components/business';
import { ShowIf, NoContent } from 'components/utils';

class BusinessForwardedList extends Component {

  static propTypes = {
    data: PropTypes.array
  }

  render() {
    const { data } = this.props;
    return (
      <div className="content">
        <ShowIf condition={data && data.length === 0}>
          <NoContent content="Không có kết quả nào" height={300}/>
        </ShowIf>
        <ShowIf condition={data && data.length > 0}>
          <table className="table table-striped businesses-forward-table">
            <thead className="thead">
              <tr className="tr-head">
                <th scope="col" className="col-lg-1">
                  #
                </th>
                <th scope="col" className="col-lg-8">
                  Doanh nghiệp
                </th>
                <th scope="col" className="col-lg-3 text-center">
                  Trạng thái
                </th>
              </tr>
            </thead>
            <tbody className="tbody">
              {data.map((business, i) => (
                <BusinessForwardedItem
                  key={business.id}
                  data={business}
                  index={(i + 1)}
                  />
              ))}
            </tbody>
          </table>
        </ShowIf>
      </div>
    );
  }
}

export default BusinessForwardedList;


// WEBPACK FOOTER //
// ./components/business/BusinessForwardedList.jsx